import throttle from './throttle'
import debounce from './debounce'
import sessionStorage from './session-storage'
import extend from './extend'
import url from './url'

export default {
  throttle,
  debounce,
  extend,
  sessionStorage,
  url
}





// WEBPACK FOOTER //
// ./src/tools/index.js